<template>
  <page>
    <div>
      <v-flex xs12>
        <form>
          <v-expansion-panels>
          <v-expansion-panel>
              <v-expansion-panel-header>
              <div>
                <v-icon>mdi-filter-variant</v-icon> Filters
              </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                      <v-flex lg6 xs6>
                        <v-autocomplete :items="bankRef" v-model="forms.bankRef" :label="labels.bankRef" item-text="label" item-value="value" :error-messages="errors.collect('bankRef')" data-vv-name="forms.bankRef" :data-vv-as="labels.bankRef"></v-autocomplete>
                      </v-flex>
                      <v-flex lg6 xs6>
                        <v-autocomplete :items="paytMeth" v-model="forms.paytMeth" :label="labels.paytMeth" item-text="label" item-value="value" :error-messages="errors.collect('paytMeth')" data-vv-name="forms.paytMeth" :data-vv-as="labels.paytMeth"></v-autocomplete>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                  <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        </form>
      </v-flex>
       <v-spacer class="mt-2"></v-spacer>
      <v-card>
        <v-flex xs12>
          <message :messages="messages"></message>
        </v-flex>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click.native="doNew">
            New Payment Status Letter<v-icon right>mdi-plus</v-icon>
          </v-btn>
        </v-card-title>
        <v-flex>
          <v-card>
            <v-data-table :headers="headers" :items="items" v-bind:options.sync="pagination" :server-items-length="totalItems" :loading="loading" :footer-props="{'items-per-page-options': itemsPerPage }" :no-data-text="noDataText">
              <template v-slot:item="row"><tr>
                <td class="text-xs-left">{{ row.item.bankRef }} </td>
                <td class="text-xs-left">{{ row.item.paytMeth }} </td>
                <td class="text-xs-left">{{ row.item.paytStat }} </td>
                <td class="text-xs-left">{{ row.item.paytStatDesc }} </td>
                 <td class="table-action-header">
                  <table-action :rowData="row" query @query="doQuery(row.item)" review @review="doReview(row.item)" remove @remove="doPromptRemove(row.item)"></table-action>
                </td>
              </tr></template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-card>
      <confirm v-model="promptRemove" @ok="doDelete">
      <p>Are you sure you want to delete Payment Status Letter?</p>
        <div class="queryValue">Bank Reference: {{selectedPaytStatLtr.bankRef}}<br/>
          Payment Method: {{selectedPaytStatLtr.paytMeth}}<br/>
          Payment Status: {{selectedPaytStatLtr.paytStat}}<br/>
        </div>
      </confirm>
    </div>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'

export default {
  data() {
    return {
      labels: {
        bankRef: 'Bank Reference',
        paytMeth: 'Payment Method'
      },
      forms: {
        bankRef: '',
        paytMeth: ''
      },
      bankRef: [],
      paytMeth: [],
      toogleArray: [false],
      loading: false,
      totalItems: 0,
      items: [],
      headers: [
        { text: 'Bank Reference', align: 'left', value: 'bankRef' },
        { text: 'Payment Method', align: 'left', value: 'paytMeth' },
        { text: 'Payment Status', align: 'left', value: 'paytStat' },
        { text: 'Payment Status Descption', align: 'left', value: 'paytStatDesc' },
        TableConst.tableActionHeader
      ],
      selectedPaytStatLtr: {
        bankRef: '',
        paytMeth: '',
        paytStat: ''
      },
      promptRemove: false,
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  methods: {
    async doInit() {
      this.fetchData()
      this.getDataList('bankRef')
      this.getDataList('paytMeth')
    },
    async fetchData() {
      this.resetMessages()
      const apiURI = this.menu.getPaytStatLtrList
      if (apiURI) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage
          }

          const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), this.forms, this.pagination.sortBy, this.pagination.sortDesc))
          if (result) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            this.items = []
            if (data) {
              data.map((data) => {
                const convertList = {
                  bankRef: data.bankRef,
                  paytMeth: data.paytMeth,
                  paytStat: data.paytStat,
                  paytStatDesc: data.paytStatDesc
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      }
    },
    doClearFilters() {
      this.forms.bankRef = ''
      this.forms.paytMeth = ''
      this.fetchData()
    },
    doFilters() {
      this.fetchData()
    },
    doNew() {
      const commit = {
        tranMode: 'new',
        bankRef: '',
        paytMeth: '',
        paytStat: ''
      }
      this.$store.commit('PAYTSTATLTR_COMMIT_KEY', commit)
      this.$router.push({ name: 'paytStatLtrDetail' })
    },
    doQuery(data) {
      const commit = {
        tranMode: 'query',
        bankRef: data.bankRef,
        paytMeth: data.paytMeth,
        paytStat: data.paytStat
      }
      this.$store.commit('PAYTSTATLTR_COMMIT_KEY', commit)
      this.$router.push({ name: 'paytStatLtrDetail' })
    },
    doReview(data) {
      const commit = {
        tranMode: 'review',
        bankRef: data.bankRef,
        paytMeth: data.paytMeth,
        paytStat: data.paytStat
      }
      this.$store.commit('PAYTSTATLTR_COMMIT_KEY', commit)
      this.$router.push({ name: 'paytStatLtrDetail' })
    },
    async doPromptRemove(data) {
      this.resetMessages()
      try {
        const expand = {
          bankRef: data.bankRef,
          paytMeth: data.paytMeth,
          paytStat: data.paytStat
        }
        const apiURI = this.menu.checkDeletePaytStatLtr
        await this.$http.get(expandURI(apiURI, expand))
        this.selectedPaytStatLtr.bankRef = data.bankRef
        this.selectedPaytStatLtr.paytMeth = data.paytMeth
        this.selectedPaytStatLtr.paytStat = data.paytStat
        this.promptRemove = true
      } catch (err) {
        const { data } = err.response
        if (data) {
          this.fieldMessage(data)
          this.notify(data)
        }
      }
    },
    doDelete() {
      this.resetMessages()
      if (this.selectedPaytStatLtr) {
        const apiURI = this.menu.deletePaytStatLtr
        if (apiURI) {
          const expand = {
            bankRef: this.selectedPaytStatLtr.bankRef,
            paytMeth: this.selectedPaytStatLtr.paytMeth,
            paytStat: this.selectedPaytStatLtr.paytStat
          }
          this.$http
            .delete(expandURI(apiURI, expand))
            .then((result) => {
              const data = result.data
              this.notify(data)
              this.promptRemove = false
              this.doInit()
            })
            .catch((err) => {
              this.promptRemove = false
              const { data } = err.response
              if (data) {
                this.message(data)
              }
            })
        }
      }
    },
    async getDataList(listName) {
      const apiUrl = this.menu.getDataList
      if (apiUrl) {
        const params = {
          listName: listName
        }
        const result = await this.$http.get(expandURI(apiUrl, params))
        if (result.data.dataList) {
          this.$set(this, listName, result.data.dataList)
        }
      }
    }
  },
  mounted() {},
  created() {
    this.doInit()
  },
  watch: {
    'pagination': function (value) {
      this.fetchData()
    }
  },
  computed: {
    menu() {
      return this.$store.state.coverLetterParam.menu
    }
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>
